import { createStore } from "@reduxjs/toolkit";
import bookReducer from '../Reducer/Reducer'
const store = createStore(bookReducer);
export default store;